import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import { api_base } from "../../env";

export default function CategoryHashTags({
  open,
  onClose,
  selectedCategories,
  setSelectedCategories,
  sendNewhastags,
}) {
  const [categories, setCategories] = useState([]);

  // Fetch categories
  useEffect(() => {
    axios
      .get(`${api_base}CategoryHasTagsRoute/getAll`)
      .then((response) => setCategories(response.data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  const handleCategoryClick = (categoryId) => {
    // Toggle selection of category
    setSelectedCategories(
      (prevSelected) =>
        prevSelected.includes(categoryId)
          ? prevSelected.filter((id) => id !== categoryId) // Deselect
          : [...prevSelected, categoryId] // Select
    );
  };

  const handleSend = () => {
    // Pass selected categories to parent component or handle as needed
    sendNewhastags();
    onClose(); // Close dialog after selecting
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{ textAlign: "center" }}
    >
      <DialogTitle>
        <Typography variant="h6">Select Categories</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {categories.map((category) => (
            <Grid item key={category.id} xs={12} sm={6} md={4}>
              <Card
                onClick={() => handleCategoryClick(category.id)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  border: selectedCategories.includes(category.id)
                    ? "2px solid #3f51b5"
                    : "1px solid #ccc",
                }}
              >
                <CardMedia
                  component="img"
                  image={`${api_base}static/${category.urlImage}`}
                  alt={category.name}
                  sx={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                  }}
                />
                <CardContent>
                  <Typography variant="h6">{category.name}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleSend}
          color="primary"
          disabled={selectedCategories.length === 0} // Disable button if no category selected
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
